import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpecifications = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M13 12C13 11.4477 13.4477 11 14 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H14C13.4477 13 13 12.5523 13 12Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M13 16C13 15.4477 13.4477 15 14 15H19C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17H14C13.4477 17 13 16.5523 13 16Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 19C13.4477 19 13 19.4477 13 20C13 20.5523 13.4477 21 14 21H22C22.5523 21 23 20.5523 23 20C23 19.4477 22.5523 19 22 19H14Z" }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 6C4 4.89543 4.89543 4 6 4H26C27.1046 4 28 4.89543 28 6V26C28 27.1046 27.1046 28 26 28H6C4.89543 28 4 27.1046 4 26V6ZM11 26H26V6H11V26ZM9 6V26H6V6H9Z"
		})
	]
});
export default SvgSpecifications;
